import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
import { TargetingSearchListApi } from '../../../api/targeting/model/targeting-search-list.api.model';
import { LeftSidebarListItemConvertableModel } from '../../../Common/Layout/models/left-sidebar-list-item-convertable.model';
import { LeftSidebarListItemButton } from '../../../Common/Layout/models/left-sidebar-list-item-button.model';
import { LeftSidebarListItem } from '../../../Common/Layout/models/left-sidebar-list-item.model';
import { SearchModeEnum} from '../../../Common/TargetingShared/enum/search-mode.enum';
import { ActionsEnum } from '../../../Common/Basic/enums/actions.enum';


/**
 * Represents the list item data structure for TargetingSearch,
 * used in LHP and other locations that require count information.
 */
export class TargetingSearchList implements AuditableModel, LeftSidebarListItemConvertableModel {

    id?: number;
    name?: string;

    createdByUserId?: number;
    createdDate?: Date;

    modifiedByUserId?: number;
    modifiedDate?: Date;

    type: SearchModeEnum;
    count?: number = null;
    hidden?: boolean;

    groupId: number;
    isFavorite: boolean;

    constructor(apiModel?: TargetingSearchListApi) {
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: TargetingSearchListApi) {
        this.id = +apiModel.id;
        this.name = apiModel.name;
        this.createdByUserId = apiModel.createdUserId;
        this.createdDate = new Date(apiModel.createdDate);
        this.modifiedByUserId = apiModel.modifiedUserId;
        this.modifiedDate = apiModel.modifiedDate ? new Date(apiModel.modifiedDate) : null;
        this.type = <SearchModeEnum>apiModel.query.searchMode;
        this.hidden = apiModel.hidden;
        this.groupId = apiModel.displayGroupId;
        this.isFavorite = apiModel.isFavorited;
    }

    constructDefault() {
        this.isFavorite = false;
    }


    toLeftSidebarListItem(buttons?: LeftSidebarListItemButton[]): LeftSidebarListItem {
        let icon, iconAriaLabel;

        switch (this.type) {
            case SearchModeEnum.outlet:
                icon = 'fa-kit fa-agpr-outlet-solid';
                iconAriaLabel = 'Discover.leftSidebar.searches.outlet.ariaLabel';
                break;
            case SearchModeEnum.contact:
            default:
                icon = 'fa-solid fa-user';
                iconAriaLabel = 'Discover.leftSidebar.searches.contact.ariaLabel';
                break;
        }

        if (this.hidden) {
            buttons = buttons.filter(button => button.key !== ActionsEnum.hide);
        }  else{
            buttons = buttons.filter(button => button.key !== ActionsEnum.show);
        }
        if (this.isFavorite) {
            buttons = buttons.filter(button => button.key !== ActionsEnum.favorite);
        } else {
            buttons = buttons.filter(button => button.key !== ActionsEnum.unfavorite);
        }

        return {
            label : this.name,
            value : this.id,
            buttons: buttons,
            status: '',
            icon: icon,
            iconAriaLabel: iconAriaLabel,
            groupId: this.groupId,
            isFavorite: this.isFavorite
        };
    }
}
